
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.5046 2.18331C4.73734 2.18331 1.6834 5.23708 1.6834 9.00406C1.6834 12.7711 4.73734 15.8248 8.5046 15.8248C10.3819 15.8248 12.0821 15.0665 13.3155 13.8394C13.3196 13.8352 13.3236 13.831 13.3278 13.8269C13.3319 13.8228 13.336 13.8188 13.3402 13.8148C14.5673 12.5814 15.3258 10.8814 15.3258 9.00406C15.3258 5.23708 12.2718 2.18331 8.5046 2.18331ZM15.0839 14.3929C16.2871 12.9259 17.0092 11.0494 17.0092 9.00406C17.0092 4.30741 13.2015 0.5 8.5046 0.5C3.80762 0.5 0 4.30741 0 9.00406C0 13.7008 3.80762 17.5082 8.5046 17.5082C10.5499 17.5082 12.4265 16.7862 13.8936 15.5832L18.563 20.2534C18.8917 20.5821 19.4247 20.5822 19.7534 20.2536C20.0821 19.9249 20.0822 19.3919 19.7535 19.0633L15.0839 14.3929Z","fill":"#8338EC"}})])
          )
        }
      }
    